
    import './styles.scoped.css';
    export default {
  "item-element": "awsui_item-element_93a1u_1q8qe_9",
  "no-content-styling": "awsui_no-content-styling_93a1u_1q8qe_21",
  "disabled": "awsui_disabled_93a1u_1q8qe_26",
  "show-divider": "awsui_show-divider_93a1u_1q8qe_33",
  "highlighted": "awsui_highlighted_93a1u_1q8qe_36",
  "is-focused": "awsui_is-focused_93a1u_1q8qe_51",
  "visual-refresh": "awsui_visual-refresh_93a1u_1q8qe_54",
  "menu-item": "awsui_menu-item_93a1u_1q8qe_58",
  "link-style": "awsui_link-style_93a1u_1q8qe_75",
  "current-breadcrumb": "awsui_current-breadcrumb_93a1u_1q8qe_112",
  "link-style-highlighted": "awsui_link-style-highlighted_93a1u_1q8qe_120",
  "has-category-header": "awsui_has-category-header_93a1u_1q8qe_126",
  "item-tooltip-wrapper": "awsui_item-tooltip-wrapper_93a1u_1q8qe_126",
  "has-checkmark": "awsui_has-checkmark_93a1u_1q8qe_126",
  "icon": "awsui_icon_93a1u_1q8qe_133",
  "checkmark": "awsui_checkmark_93a1u_1q8qe_137",
  "external-icon": "awsui_external-icon_93a1u_1q8qe_144",
  "content-wrapper": "awsui_content-wrapper_93a1u_1q8qe_148",
  "main-row": "awsui_main-row_93a1u_1q8qe_154",
  "label-tag": "awsui_label-tag_93a1u_1q8qe_161",
  "secondary-text": "awsui_secondary-text_93a1u_1q8qe_168"
};
  